'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = defineRetryDecorator;

var _q = require('q');

var _q2 = _interopRequireDefault(_q);

var _errors = require('../errors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function defineRetryDecorator(_ref) {
  var _ref$retryLimit = _ref.retryLimit,
      retryLimit = _ref$retryLimit === undefined ? Infinity : _ref$retryLimit;

  return function retryDecorator(resolver) {
    var failureCount = 0;

    return function () {
      if (failureCount > retryLimit) {
        return _q2.default.reject(new _errors.RetryError());
      }

      var promise = resolver.apply(undefined, arguments);

      promise.then(function () {
        return failureCount = 0;
      }, function () {
        return failureCount++;
      });

      return promise;
    };
  };
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/PubNubJS/static-1.19/js/decorators/defineRetryLimitDecorator.js
// module id = 456
// module chunks = 0